export const conditions = {
    "0": "中毒",
    "1": "致命的",
    "2": "藥水中毒",
    "3": "麻痺",
    "4": "沉默",
    "5": "石化",
    "6": "膽小",
    "7": "狂暴",
    "8": "混亂",
    "9": "戰鬥經驗值2倍",
    "10": "懶散",
    "11": "幸運",
    "12": "衰運",
    "13": "長官的祝福",
    "14": "爆發",
    "15": "爆發",
    "16": "海市蜃樓",
    "17": "懦弱",
    "18": "PVP 處罰",
    "19": "無力",
    "20": "解除闇黑武士",
    "21": "偽裝",
    "22": "受祝福的",
    "23": "隱形",
    "24": "無法交易",
    "25": "緊追",
    "26": "禁止密語",
    "27": "觀看拍圖",
    "28": "合奏",
    "29": "瞄準準確度提升",
    "30": "高速詠唱",
    "31": "戰鬥強度弱化",
    "32": "哈哈蘑菇餅乾",
    "33": "淚眼烏龍麵",
    "34": "瘋狂巧克力球",
    "35": "高傲牛排",
    "36": "心動的加藤巧克力",
    "37": "毒免疫",
    "38": "石化免疫",
    "39": "魔法值消耗減少",
    "40": "耐力值消耗減少",
    "41": "暴發抵抗",
    "42": "破碎踏擊抵抗",
    "43": "魔法值消耗增加",
    "44": "耐力值消耗增加",
    "45": "友情的蝦仁炒飯",
    "46": "火之魔法盾",
    "47": "冰之魔法盾",
    "48": "雷之魔法盾",
    "49": "自然魔法盾",
    "50": "緩慢移動",
    "51": "採集達人",
    "52": "突擊",
    "53": "攻擊速度增加",
    "54": "달빛 이팩트 컨디션",
    "55": "硫磺中毒",
    "56": "火傷",
    "57": "冰",
    "58": "星星糖果",
    "59": "魔力盾牌",
    "60": "벚꽃놀이",
    "62": "魔法施展速度增加",
    "63": "攻擊力增加",
    "64": "반투명",
    "65": "전투 경험치 1.1배",
    "66": "戰鬥經驗值2倍",
    "67": "眩惑",
    "68": "大象淋浴",
    "69": "詛咒",
    "70": "失明",
    "71": "冰 - 沒有視覺效果",
    "72": "變更生產技能成功率",
    "73": "增加物品熟悉度",
    "74": "接受鍊金術造雨效果",
    "75": "程式檢查失敗",
    "76": "寒冰送葬狀態",
    "77": "生魂",
    "78": "半神化",
    "79": "生魂的笑",
    "80": "生魂的痛苦",
    "81": "情人節的幸福",
    "82": "情人節的不幸",
    "83": "服裝表演",
    "84": "거대상체",
    "85": "혀가 꼬임",
    "86": "거대하체",
    "87": "키가 커짐",
    "88": "키가 작아짐",
    "89": "收到祝福的效果",
    "90": "狂暴效應",
    "91": "使用迷你藥水",
    "92": "無法使用藥水和食物的狀態",
    "93": "巨蛇石阻擋的狀態",
    "94": "高電壓",
    "95": "서서 하는 이펙트",
    "96": "生活技能修練增加",
    "97": "戰鬥技能修練增加",
    "98": "魔法技能修練增加",
    "99": "鍊金術技能修練增加",
    "100": "名字顏色變更",
    "101": "設置塔座鋼瓶",
    "102": "半神化力量增加",
    "103": "半神化敏捷增加",
    "104": "半神化意志增加",
    "105": "半神化幸運增加",
    "106": "半神化智力增加",
    "107": "半神化光之狂怒傷害值增加",
    "108": "半神化光之矛傷害值增加",
    "109": "半神化闇影之靈傷害值增加",
    "110": "半神化持續時間增加",
    "111": "半神化冷卻時間減少",
    "112": "裝備布里歐納克時傷害值增加",
    "113": "裝備布里歐納克時暴擊機率增加",
    "114": "魔法樂譜演奏效果增加",
    "115": "移動速度增加",
    "116": "半神化無敵狀態",
    "117": "變更高度的狀態",
    "118": "受到烏鴉攻擊的狀態",
    "119": "半神化闇影之靈傷害值增加",
    "120": "在騎乘的狀態可以進行攻擊",
    "121": "能力值減少狀態",
    "122": "闇影水晶",
    "123": "道具獲得率增加狀態",
    "124": "道具獲得率增加狀態",
    "125": "釣魚機率增加",
    "126": "釣魚機率增加",
    "127": "聊天顏色變更",
    "128": "戰鬥經驗值增加",
    "129": "支援箭",
    "131": "諾亞達套裝道具",
    "132": "舞台地下城 聚光燈照明圈",
    "133": "哈默林的契約",
    "134": "脫離肉體",
    "135": "靈魂解除",
    "136": "빙수 그릇을 들고 있는 상태",
    "137": "巨魔恢復",
    "138": "強化重擊",
    "139": "強化躍擊",
    "140": "強化突擊",
    "141": "強化冰矛",
    "142": "強化火焰",
    "143": "強化治癒",
    "144": "強化火焰噴射",
    "145": "強化水炮",
    "146": "強化吸取生命",
    "147": "強化穿心箭",
    "148": "強化支援箭",
    "149": "強化釣魚",
    "150": "強化冶煉",
    "151": "強化打鐵",
    "152": "強化淘金術",
    "153": "鎧甲熊怒吼",
    "154": "裝備迷迭香手套",
    "155": "疾速飛行",
    "156": "追蹤克勞迪斯",
    "157": "寵物訓練工具",
    "158": "使用寵物訓練工具增加移動速度",
    "159": "使用寵物訓練工具增加飛行速度",
    "160": "完成每日任務",
    "161": "拉狄卡升上去",
    "162": "OX 機智問答",
    "163": "寵物地上加速",
    "164": "貿易運送狀態",
    "165": "半神化翼之蝕強化",
    "166": "半神化翼之狂暴強化",
    "167": "馬努斯的健康秘藥",
    "168": "移動速度增加",
    "169": "移動速度增加, 採集速度增加",
    "170": "解除武器封印",
    "171": "身體要變小了",
    "172": "由於細緻工匠移動速度增加",
    "173": "由於細緻工匠交叉移動速度增加",
    "174": "使用釣魚用椅子",
    "175": "保證書",
    "176": "使用移動速度增加藥水",
    "177": "魔法攻擊力強化",
    "178": "殭屍感染",
    "179": "樂器演奏石化",
    "180": "金幣攻擊強化",
    "181": "通緝犯追蹤模式",
    "182": "連續技能 : 螺旋勾拳",
    "183": "復原後遺症",
    "184": "增加移動速度(目前的武鬥家The King使用)",
    "185": "被猛烈突擊後摔倒的狀態",
    "186": "暈眩 (被筋斗踢打中時, 無法使用魔法鍊金術)",
    "187": "猛烈突擊狀態",
    "188": "梅魯的詛咒",
    "189": "增加武鬥技能修練",
    "190": "隨著角色走的狀態",
    "191": "接收炸彈超人活動的炸彈狀態中",
    "192": "活潑板",
    "193": "進行曲",
    "194": "豐年歌",
    "195": "和平的音樂",
    "196": "亂打",
    "197": "수호의 영혼석 사용",
    "198": "無法進行貿易狀態",
    "199": "音樂技能修練增加",
    "200": "增加修練人偶術技能",
    "201": "以復活花火來復活",
    "202": "用金絲線綁住",
    "203": "被線纏住有出血的狀態",
    "204": "雅芬水晶",
    "205": "賞金獵人模式",
    "206": "使用人偶靈魂技能中",
    "207": "因被擊而無法施展的超級盔甲",
    "208": "人偶螺旋狀效果(防禦保護增加)",
    "209": "技能用一般靜止",
    "210": "強烈的復活花火",
    "211": "骨龍惡魔的爆走",
    "212": "骨龍惡魔消滅",
    "213": "變身術強化",
    "214": "增加傷害",
    "215": "減少傷害",
    "216": "減少防禦, 保護",
    "217": "加快技能的修練",
    "218": "旋風擺蓮腿強化",
    "219": "蜘蛛網纏身",
    "220": "狂暴化",
    "221": "安息之風",
    "222": "安眠之風",
    "223": "防禦, 保護增加",
    "224": "不會倒下的狀態",
    "225": "衝擊吸收",
    "226": "任務經驗值上升",
    "227": "突襲水晶",
    "228": "對龍攻擊力上升",
    "229": "貢獻度獎勵",
    "230": "雙槍射擊槍",
    "231": "增加修練雙槍技能",
    "232": "翅膀使用狀態",
    "233": "메테오 스트라이크 도트 대미지",
    "234": "導電反應",
    "235": "凍傷點傷害",
    "236": "強化躍擊",
    "237": "엔진 쇼크",
    "238": "뮤직 코러스를 사용 한 상태",
    "239": "탄식의 송가",
    "240": "元素波動",
    "241": "黃金時間",
    "242": "準備安裝型樂器演奏",
    "243": "生活技能修練增加(當日效果)",
    "244": "戰鬥經驗值 2倍(當日效果)",
    "245": "影任經驗值再次獲得(當日效果)",
    "246": "套用強化火花感電效果",
    "247": "套用風屬性鍊金術被動效果",
    "248": "선베드 2인용",
    "249": "深淵的詛咒",
    "250": "公爵的流血",
    "251": "公爵的誘惑",
    "252": "逃脫危機",
    "253": "인식 불가",
    "254": "나오의 축복(초보 펫 보너스)",
    "255": "鬼嚎",
    "256": "深沉的嗓音",
    "257": "野獸的爆吼",
    "258": "跳舞時間",
    "259": "狂暴化的鬼",
    "260": "殭屍的保護",
    "261": "萬聖節分流效果",
    "262": "萬聖節世界",
    "263": "飛行加速器",
    "266": "石化",
    "267": "狂風加速器",
    "269": "화가난",
    "270": "貿易移動速度增加",
    "271": "甜甜蜜蜜",
    "272": "料理生產經驗值上升",
    "273": "사다리 오르는",
    "274": "전투모드 돌입",
    "275": "移動速度增加",
    "276": "防禦 減少",
    "277": "보스무적",
    "278": "보스 앰비언트 사운드",
    "279": "被侵染的魯艾利猛擊技能持續傷害",
    "280": "影子任務經驗值增加",
    "281": "忍者技能修練增加",
    "282": "移動採集速度增加",
    "283": "力量,負傷,魔力,耐力恢復率上升",
    "284": "잠재우기",
    "285": "잠재우기 감속",
    "286": "反效果解除",
    "287": "爽快的心情",
    "288": "侵蝕病",
    "289": "禁錮",
    "290": "炙熱效果",
    "291": "神聖束縛時間",
    "292": "神聖懲戒時間",
    "293": "使者防禦",
    "294": "神聖懲戒強化效果",
    "295": "聖盾庇護",
    "296": "聖光之錐",
    "297": "胖子",
    "298": "神聖防禦之力",
    "299": "聖光之錐的神聖傷害",
    "300": "無法召喚寵物的狀態",
    "301": "炙熱減益",
    "302": "冥想",
    "303": "防止走音",
    "304": "化身",
    "305": "水瓶座",
    "306": "雙魚座",
    "307": "牡羊座",
    "308": "金牛座",
    "309": "雙子座",
    "310": "巨蟹座",
    "311": "獅子座",
    "312": "處女座",
    "313": "天秤座",
    "314": "天蠍座",
    "315": "射手座",
    "316": "摩羯座",
    "317": "近距離戰鬥效果出血",
    "318": "近距離戰鬥效果昏厥",
    "319": "近距離戰鬥效果防禦保護減少",
    "320": "교역 로그아웃 패널티 면제",
    "321": "猛擊連續技",
    "322": "猛擊連續技max",
    "323": "憤怒衝擊",//傷害詛咒 2,
    "324": "暴擊傷害增加",
    "325": "強化猛擊",
    "326": "裝備耐久度消耗量減少",
    "327": "休眠羊毛",
    "328": "魅力四射",
    "329": "跟羊毛一樣的輕巧",
    "330": "受到冰刃攻擊凍結狀態",
    "331": "受到冰矛攻擊遲緩狀態",
    "332": "生命值增加",
    "333": "最大傷害增加",
    "334": "生命值恢復速度增加",
    "335": "魔力恢復速度增加",
    "336": "耐力恢復速度增加",
    "337": "暴擊機率增加",
    "338": "特定才能技能修練值獲得量增加",
    "339": "近距離戰鬥才能技能傷害增加",
    "340": "魔法才能技能施展速度增加",
    "341": "弓手才能瞄準速度增加",
    "342": "採集速度與成功率增加",
    "343": "披著羊皮的狼世界任務確認",
    "344": "遠距離攻擊系列額外攻擊傷害",
    "345": "束縛",
    "348": "마력공급",
    "349": "마력차단",
    "350": "十二試煉",
    "351": "灰色煙幕術",
    "352": "靈魂連結狀態",
    "353": "靈魂連結狀態",
    "354": "料理修練值效果",
    "355": "料理修練值效果",
    "356": "料理品質效果",
    "357": "料理增益持續時間增加效果",
    "358": "強化審判之刃",
    "359": "強化騎槍衝擊",
    "360": "狄娜希召喚技能",
    "361": "移動速度增加(狄娜希)",
    "362": "攻擊速度增加(狄娜希)",
    "363": "歸來的米列希安效果",
    "364": "放天燈狀態",
    "365": "製作成功率效果",
    "366": "閃爍的誘惑",
    "367": "遊魂暴走",
    "368": "遊魂怒吼",
    "369": "觀賞公演中",
    "370": "甜蜜幻象",
    "371": "戰鬥經驗值效果(活動)",
    "372": "無法使用氣球復活狀態",
    "373": "辨識解除",
    "374": "浪漫假髮狀態1",
    "375": "浪漫假髮狀態2",
    "376": "浪漫假髮狀態3",
    "378": "首領怪物攻擊確認狀態",
    "379": "戰鬥摩托車召喚技能",
    "380": "很生氣對吧?",
    "381": "寵物戰鬥經驗值增加",
    "382": "移動速度增加(圖騰)",
    "383": "射擊遊戲狀態",
    "384": "音樂盒播放狀態",
    "385": "愉悅心情狀態",
    "386": "移動速度增加(拉狄卡)",
    "387": "攻擊延遲減少",
    "388": "最大傷害增加",
    "389": "魔法攻擊力增加",
    "390": "無法技能召喚狀態.",
    "391": "點攻擊免疫狀態",
    "392": "纏繞的閃電",
    "393": "旋律舞步",
    "394": "全身感應狀態",
    "395": "受到祝福的旋律舞步效果",
    "396": "恢復藥水效果增加",
    "397": "探險經驗值增加",
    "398": "Huge Lucky增加",
    "399": "能力值提升",
    "400": "生產經驗值增加",
    "401": "戰鬥經驗值增加",
    "402": "魔法值消耗量減少",
    "403": "耐力值消耗量減少",
    "404": "暴擊傷害增加",
    "405": "妖魔迷你藥水狀態",
    "406": "拉狄卡的氣息",
    "407": "拉狄卡的視線",
    "408": "拉狄卡的力量",
    "409": "神聖技能修練增加",
    "410": "死亡之舞",
    "411": "死亡之舞效果",
    "412": "迴避辨識狀態",
    "413": "出血狀態",
    "414": "攻擊速度增加(寵物)",
    "415": "移動速度增加(寵物)",
    "417": "妨礙連結",
    "419": "憤怒狀態",
    "420": "敵人移動速度減少",
    "421": "移動速度增加(拉姆)",
    "422": "探險經驗值增加",
    "423": "農場石開採權利者",
    "424": "無法移動",
    "425": "信念值狀態",
    "426": "死神烙印",
    "427": "黑闇解放",
    "428": "信念值狀態",
    "429": "烈焰見習騎士團任務經驗值效果",
    "430": "闇夜鎖鏈技能修練增加",
    "431": "獲得娜歐祝福的",
    "432": "去探險吧",
    "433": "冥想的藥水",
    "434": "神聖經驗值2倍增加",
    "435": "音樂增益技能效果增加",
    "436": "黑闇值獲得量增加",
    "437": "死神烙印傷害值增加",
    "438": "攻擊延遲減少",
    "439": "水瓶座",
    "440": "雙魚座",
    "441": "牡羊座",
    "442": "金牛座",
    "443": "雙子座",
    "444": "巨蟹座",
    "445": "獅子座",
    "446": "處女座",
    "447": "天秤座",
    "448": "天蠍座",
    "449": "射手座",
    "450": "摩羯座",
    "451": "稜鏡",
    "452": "水藍光稜鏡",
    "454": "情侶同步",
    "455": "組隊效果",
    "456": "黃光稜鏡",
    "457": "粉黃光稜鏡",
    "458": "天藍光稜鏡",
    "460": "無法使用神聖技能",
    "461": "暴擊反擊",
    "462": "存在弱點部位",
    "463": "神聖經驗值增加",
    "464": "冰雪狀態",
    "465": "冰雪狀態",
    "466": "閃爍",
    "467": "迷你束縛",
    "468": "異神化加強",
    "469": "移動速度減少",
    "470": "異神化",
    "471": "娃娃同行獎勵",
    "472": "烈焰見習騎士團戰鬥經驗值增加",
    "473": "溫暖的殘香",
    "474": "크리티컬 대미지 증가",
    "475": "음악 버프 스킬 효과 증가",
    "476": "要害貫通",
    "477": "快速",
    "478": "超越:生命",
    "479": "堅定意志",
    "480": "紫光稜鏡",
    "481": "綠光稜鏡",
    "482": "紅光稜鏡",
    "483": "元素打磨",
    "484": "元素打磨",
    "485": "元素打磨",
    "486": "堅硬",
    "487": "時間歪曲",
    "488": "露娜的成長支援",
    "489": "露娜的成長支援1階段",
    "490": "露娜的成長支援2階段",
    "491": "露娜的成長支援3階段",
    "492": "露娜的成長支援Bonus",
    "493": "露娜的特別支援",
    "494": "無敵",
    "495": "幻想光圈用狀態",
    "496": "生命值和負傷恢復",
    "497": "起死回生發動機率增加",
    "498": "堅定意志持續時間增加",
    "499": "超越 : 生命持續時間增加",
    "500": "連續攻擊發動機率增加",
    "501": "要害貫通持續時間增加",
    "502": "快速持續時間增加",
    "503": "無力化狀態",
    "504": "雷電交加",
    "505": "起死回生發動機率增加",
    "506": "堅定意志持續時間增加",
    "507": "超越 : 生命持續時間增加",
    "508": "連續攻擊發動機率增加",
    "509": "要害貫通持續時間增加",
    "510": "快速持續時間增加",
    "511": "銳利",
    "512": "再生",
    "513": "迅速",
    "514": "隱身",
    "515": "逆轉",
    "516": "覺醒",
    "517": "集中引誘 - 施展者",
    "518": "集中引誘 - 對象者",
    "519": "集中引誘",
    "520": "強健",
    "521": "洞察之眼",
    "522": "再生之域",
    "523": "採集成功機率增加",
    "524": "強化蜂擁",
    "525": "強化終焉斬擊",
    "526": "終焉斬擊",
    "527": "近距離戰鬥技能連結強化",
    "528": "馬納南升起的水",
    "529": "蠶食",
    "530": "達雷克幻象",
    "532": "強化戰鬥鍊金術",
    "533": "強化鍊成鍊金術",
    "534": "強化英雄鍊金術",
    "535": "人偶僵直防禦機率增加",
    "536": "強化人偶暴擊效果",
    "537": "人偶術才能技能冷卻時間減少",
    "538": "特別秘藥效果",
    "539": "海怪雷克斯墨汁 技能盾牌",
    "540": "玩家是否處於被海怪的腳纏繞勒緊的狀態 檢查的狀態",
    "541": "海怪的毒",
    "542": "戰鬥經驗值增加",
    "543": "寵物 魔法盾",
    "544": "魔法防禦, 魔法保護增加",
    "545": "治癒之光",
    "546": "廣域恢復效果",
    "547": "紐帶之繩",
    "548": "AP獲得2倍",
    "549": "特別的輔助",
    "550": "移動速度增加",
    "551": "出血",
    "552": "防禦保護減少",
    "553": "射程距離增加",
    "554": "魔力恢復",
    "555": "阻斷",
    "556": "演唱會觀賞效果",
    "557": "火傷",
    "558": "水瓶座星星秘藥",
    "559": "雙魚座星星秘藥",
    "560": "牡羊座星星秘藥",
    "561": "金牛座星星秘藥",
    "562": "雙子座星星秘藥",
    "563": "巨蟹座星星秘藥",
    "564": "獅子座星星秘藥",
    "565": "處女座星星秘藥",
    "566": "天秤座星星秘藥",
    "567": "天蠍座星星秘藥",
    "568": "射手座星星秘藥",
    "569": "魔羯座星星秘藥",
    "570": "戰鬥經驗值5倍",
    "571": "惡夢",
    "572": "減益效果防禦",
    "573": "戰鬥經驗值增加",
    "574": "強化雷氣鎖鏈",
    "575": "所有技能修練值3倍增加",
    "576": "不屈的槍騎兵",
    "577": "精靈實體化技能增益效果",
    "578": "魔法光圈",
    "579": "光的烙印",
    "580": "衰落的沼澤中毒",
    "581": "觀賞演唱會效果 1階段 : 寵物戰鬥經驗值 2倍",
    "582": "幸福的氣息效果",
    "583": "衰弱",
    "584": "暴走的時間",
    "585": "神速的翅膀",
    "586": "밀레시안 부스터",
    "587": "泰因屬性燒傷",
    "588": "加歐屬性感染",
    "589": "芬恩寵物專用飼料增益",
    "590": "芙露亞盾牌",
    "591": "芙露亞盾牌",
    "592": "花瓣的保護",
    "593": "失去力量的狀態(芙露亞)",
    "594": "跑跑卡丁車水球",
    "595": "跑跑卡丁車 UFO",
    "596": "有效射程追加",
    "597": "솟구치는 분노 면역",
    "598": "跑跑卡丁車水球",
    "599": "擊中強化",
    "600": "跑跑卡丁車飛彈",
    "601": "擊中強化",
    "602": "跑跑卡丁車盾牌",
    "603": "石化",
    "604": "스위트 로즈 가시에 찔린",
    "605": "甜蜜玫瑰旋律舞步",
    "606": "組隊效果",
    "607": "所有技能修練值2倍",
    "609": "海米斯的悄悄話",
    "610": "火花結晶",
    "611": "停止動作",
    "612": "刻印 : 弗拉加拉赫",
    "613": "營火精靈的朋友",
    "614": "可愛的叫聲",
    "615": "可愛的行為",
    "616": "聖靈同步和聲",
    "617": "營火和聲",
    "618": "貿易和聲",
    "619": "採集和聲",
    "620": "鐵匠技術和聲",
    "621": "剪羊毛和聲",
    "622": "木工和聲",
    "623": "寵物訓練和聲",
    "624": "好奇心的和聲",
    "625": "開心的和聲",
    "626": "歡樂的Japari公園",
    "627": "歡樂的Japari公園待機",
    "628": "魔法施展速度增加",
    "629": "暴擊傷害增加",
    "630": "詛咒的傷害",
    "637": "可愛的行為",
    "638": "情侶同步",
    "639": "원문수정해서 사용하세요",
    "640": "角色移動速度設定",
    "641": "皇家學院水晶",
    "642": "원문수정해서 사용하세요",
    "643": "星塵支援效果 5",
    "644": "水波",
    "645": "淨化的水波",
    "646": "防禦, 保護減少",
    "647": "傷害減少",
    "648": "傷害增加",
    "649": "魔法攻擊力強化",
    "650": "雹暴強化",
    "651": "雷氣鎖鏈累積降低",
    "652": "火石狂熱強化",
    "653": "守護的氣勢",
    "654": "湧入的氣息",
    "655": "寬容的祝福",
    "656": "變異體碎片",
    "657": "變異體強化",
    "658": "幻想的合唱效果強化",
    "659": "音樂Buff持續時間增加",
    "660": "活潑板Buff效果增加",
    "661": "戰場的序曲Buff效果增加",
    "662": "忍耐的音樂Buff效果增加",
    "663": "豐年歌Buff效果增加",
    "664": "搖籃曲Buff效果增加",
    "665": "進行曲Buff效果增加",
    "666": "伊魯夏死亡的烙印",
    "667": "伊魯夏虛弱的烙印",
    "668": "伊魯夏束縛的烙印",
    "669": "伊魯夏餅乾的烙印",
    "670": "耐久度消耗量減少",
    "671": "道具獲得率增加藥水",
    "672": "爾格光束後遺症",
    "673": "爾格中毒",
    "674": "死刑宣告",
    "675": "混亂",
    "676": "神的庇護",
    "677": "附身",
    "678": "無法使用藥水和食物的狀態",
    "679": "變得更堅固",
    "680": "戰場的序曲",
    "681": "忍耐的音樂",
    "682": "近距離強化",
    "683": "強化弓術",
    "684": "強化魔法",
    "685": "強化鍊金術",
    "686": "強化武鬥術",
    "687": "強化人偶術",
    "688": "強化雙槍",
    "689": "強化忍術",
    "690": "強化鎖鏈",
    "691": "強化治癒",
    "692": "強化音樂",
    "693": "防禦增加",
    "694": "保護增加",
    "695": "生命力增加",
    "696": "魔力增加",
    "697": "強化旋風擺蓮腿",
    "698": "強化無限斬擊",
    "699": "強化終焉斬擊",
    "700": "強化騎槍衝擊馬上突擊",
    "701": "強化爆裂箭",
    "702": "強化衝射",
    "703": "強化箭系組合魔法",
    "704": "強化連續技能 : 飛踢",
    "705": "強化第二幕 : 激增的憤怒",
    "706": "強化暴烈猛擊",
    "707": "強化雹暴",
    "708": "強化闇夜掠擊",
    "709": "強化鎖鏈刺擊",
    "710": "強化手裏劍暴風",
    "711": "爾格暴增",
    "712": "藥水消化不良狀態",
    "713": "生產技能生產成功率 20% 增加",
    "714": "強化雙槍射擊",
    "715": "強化終極射擊",
    "716": "小步狐的標示",
    "717": "小步狐的幸運",
    "718": "小步狐的特別禮物",
    "719": "強化櫻花雨",
    "720": "強化中級魔法",
    "721": "怪物傷害值增幅",
    "722": "聚能機率增加",
    "723": "回音石升級機率增加",
    "724": "減少恢復 1階段",
    "725": "減少恢復 2階段",
    "726": "減少恢復 3階段",
    "727": "腐蝕防具 1階段",
    "728": "腐蝕防具 2階段",
    "729": "腐蝕防具 3階段",
    "730": "腐蝕武器 1階段",
    "731": "腐蝕武器 2階段",
    "732": "腐蝕武器 3階段",
    "733": "魅魔的誘惑",
    "734": "魅魔的誘惑",
    "735": "戰爭狂的亡靈",
    "736": "先驅者的亡靈",
    "737": "漫遊者的亡靈",
    "738": "藝術家的亡靈",
    "739": "引導者的亡靈",
    "740": "貿易移動速度增加(鞋子)",
    "741": "貿易移動速度增加(藥水)",
    "742": "稀原工學產物品質增加",
    "743": "魔法製造產物品質增加",
    "744": "打鐵產物品質增加",
    "745": "製作衣服產物品質增加",
    "746": "木工產物品質增加",
    "747": "優質戰鬥服務",
    "748": "優質生活服務",
    "749": "烈焰騎士團等級限制解除",
    "750": "掠奪團相遇糖果",
    "751": "掠奪團相遇保護狀態",
    "752": "隱身中忍者技能效果",
    "756": "成長支援狀態",
    "757": "成長支援藥水",
    "758": "成長支援狀態",
    "759": "特別支援狀態",
    "760": "精通屬性魔法傷害增加",
    "761": "魔力盾牌效果",
    "762": "強化移動投擲",
    "763": "移動速度增加(強化移動投擲)",
    "764": "貿易中移動速度增加5%.",
    "765": "購買貿易品折扣率增加1%.",
    "766": "販賣貿易品時價差獲利增加10%.",
    "767": "貿易時信用度上升率上升2%.",
    "768": "戰鬥經驗值2倍.",
    "769": "生活技能修練值2倍.",
    "770": "戰鬥技能修練值2倍.",
    "771": "冥想效果.",
    "772": "飛行帆船移動速度",
    "773": "商團貿易 - 完成航空移動時,所獲得的賽季杜卡特差額增加",
    "774": "商團貿易 - 完成航空移動時,信用度增加",
    "775": "飛行帆船弩砲攻擊速度增加",
    "776": "飛行帆船 無敵",
    "777": "古代石像 : 貿易品差額增加",
    "778": "古代石像 : 掠奪團見面保護",
    "779": "狂風氣流 : 飛行帆船速度增加",
    "780": "貿易處罰減少",
    "781": "事半功倍的補藥氣息",
    "782": "急速生產的補藥氣息",
    "783": "一夜暴富的補藥氣息",
    "784": "如願以償的補藥氣息",
    "785": "技能傷害增加",
    "786": "公會團結的力量",
    "787": "清爽的氣息",
    "788": "強化回音石升級",
    "789": "強化特殊改造成功",
    "790": "強化特性成長",
    "791": "強化評價成長",
    "792": "強化精靈成長",
    "793": "賦予火之自然力",
    "794": "賦予冰之自然力",
    "795": "賦予雷之自然力",
    "796": "守護的祝福",
    "797": "聖詠者吸血+傷害增加",
    "798": "轉移的死亡",
    "799": "聖詠者攻擊增益效果",
    "800": "活力之聲",
    "801": "救贖的迴聲",
    "802": "甦醒的讚歌",
    "803": "崩壞的波動",
    "804": "賦予冰之自然力被擊狀態",
    "805": "精通黑闇強化",
    "806": "精通連續技能強化",
    "807": "守護的祝福",
    "808": "淨化的鼓動",
    "809": "魔力盾牌強化",
    "810": "妖精光芒的束縛",
    "811": "聲波氣息傷害",
    "812": "聲波擺盪",
    "813": "戰場的和聲",
    "814": "豐饒的和聲",
    "815": "高速的和聲",
    "816": "藥水中毒危險",
    "817": "烈焰等級上限解除",
    "818": "增加戰鬥經驗值",
    "819": "重生時追加升級",
    "820": "增加獲得AP",
    "821": "技能等級提升獎勵",
    "822": "技能修練增益效果",
    "823": "增加神聖經驗值",
    "824": "增加裝備熟練度",
    "825": "增加寵物特技修練值",
    "826": "增加寵物點數",
    "827": "增加獲得寵物/夥伴經驗值",
    "828": "增加獲得特性璞黎",
    "829": "增加評價經驗值",
    "830": "增加學會支援獎勵",
    "831": "增加精靈經驗值",
    "832": "傷害增加",
    "833": "聚能經驗值增加",
    "834": "特別的戰鬥秘藥",
    "836": "和希里原同化的狀態",
    "837": "和稀原同化的狀態",
    "838": "寒冰旋風",
    "839": "寒冰旋風緩慢狀態",
    "840": "收集四散的記憶碎片的無敵狀態",
    "841": "強化無限斬擊",
    "842": "猛擊強化",
    "843": "終焉斬擊強化",
    "844": "暴擊傷害增加",
    "845": "減緩耐久度減少",
    "846": "暴烈猛擊強化",
    "847": "蜂擁強化",
    "848": "箭系組合魔法強化",
    "849": "魔法攻擊力增加",
    "850": "雹暴強化",
    "851": "中級魔法強化",
    "852": "爆裂箭強化",
    "853": "終極射擊強化",
    "854": "連鎖鋼瓶冷卻時間減少",
    "855": "所有屬性鍊金術傷害",
    "856": "連續技傷害增加",
    "857": "暴擊發動時,連續技冷卻時間初始化機率",
    "858": "人偶術冷卻時間減少",
    "859": "人偶暴擊傷害倍率",
    "860": "人偶死亡時有機率復活",
    "861": "櫻花雨強化",
    "862": "手裏劍暴風強化",
    "863": "雙槍射擊強化",
    "864": "衝射強化",
    "865": "鎖鏈刺擊強化",
    "866": "闇夜掠擊強化",
    "867": "增加學會支援獎勵",
    "868": "增加精靈經驗值",
    "869": "戰鬥經驗增加,AP獲取增加",
    "870": "AP獲得增加",
    "871": "一代宗師印章增加獲得券",
    "872": "雙手武器無限斬擊強化",
    "873": "最大傷害強化",
    "874": "生命的溫度",
    "875": "經驗符咒效果",
    "877": "精靈符咒效果",
    "879": "後援符咒效果",
    "880": "生產符咒效果",
    "881": "修練符咒效果",
    "882": "怪物銳利",
    "883": "嚴重凍傷",
    "884": "相同才能攻擊免疫",
    "885": "BOSS房日間組(右側)",
    "886": "BOSS房夜間組(左側)",
    "887": "遠距離攻擊系列攻擊傷害增加",
    "888": "BOSS瞬移用透明化",
    "889": "憤怒衝擊強化",
    "890": "強化不屈不撓的鬥志",
    "891": "不屈不撓",
    "893": "嘲諷防禦 /魔法防禦上升",
    "894": "時間逆行",
    "895": "不穩定的靈魂",
    "896": "恢復鬥志",
    "897": "寒氣",
    "898": "時間分裂:日",
    "899": "時間分裂:夜",
    "900": "聚能開放機率增加",
    "902": "結局",
    "903": "撕咬冰脊野狼",
    "904": "秘法獲得經驗值增加",
    "905": "暴擊率增加",
    "906": "增加鍊金術傷害",
    "907": "銳利免疫效果",
    "908": "配對生命Bonus效果",
    "909": "家族旅行照片",
    "910": "家族旅行影片",
    "911": "家族旅行票根",
    "912": "喵喵的喵皇降臨",
    "913": "喵喵的喵皇降臨",
    "914": "肉球的庇護",
    "915": "肉球的庇護",
    "916": "喵喵的幸運",
    "917": "增加工程率",
    "918": "增加生產成功率",
    "919": "增加Huge Lucky",
    "920": "精通火魔法傷害增加",
    "921": "精通冰魔法傷害增加",
    "922": "精通雷魔法傷害增加",
    "923": "魔法施展速度增加",
    "924": "治癒效果增加",
    "925": "依照治癒效果治療負傷",
    "926": "移動速度 增加",
    "927": "寒冰送葬目標狀況",
    "928": "增加額外傷害",
    "929": "增加保護 / 魔法保護",
    "930": "移動速度增加",
    "931": "魔力封鎖目標狀況",
    "932": "聖靈同步強化",
    "933": "永遠的祈禱強化",
    "934": "祈禱",
    "936": "集中力恢復",
    "938": "魔力穿刺",
    "939": "帕艾雅的庇護",
    "940": "霰彈射擊",
    "941": "鍊金加成:過熱",
    "942": "鍊金加成:腐蝕",
    "943": "屬性轉換:魔力",
    "944": "防禦意志",
    "945": "戰鬥意志",
    "946": "象徵效果賦予成功率增加",
    "947": "移動速度增加",
    "948": "暗雷連結目標狀況",
    "949": "汪汪!",
    "950": "強化衝射",
    "951": "強化雙槍射擊",
    "952": "強化手裏劍暴風",
    "953": "強化櫻花雨",
    "954": "強化旋風擺蓮腿",
    "955": "強化無限斬擊",
    "956": "強化終焉斬擊",
    "957": "強化蜂擁",
    "958": "強化暴烈猛擊",
    "959": "強化重擊",
    "960": "強化猛擊",
    "961": "強化猛擊",
    "962": "強化爆裂箭",
    "963": "強化終極射擊",
    "964": "強化終極射擊",
    "965": "強化雹暴",
    "966": "強化中級魔法",
    "967": "強化箭系組合魔法",
    "968": "強化騎槍衝擊馬上突擊",
    "969": "魔法攻擊力增加(兇猛禁忌魔導書)",
    "970": "強化闇夜掠擊",
    "971": "強化鎖鏈刺擊",
    "972": "妨礙連結",
    "973": "騎槍衝擊強化",
    "974": "騎槍衝擊速度增加(未搭乘)",
    "975": "騎槍衝擊搭乘效果(未搭乘)",
    "976": "猛擊突拳套用",
    "977": "處決的時間強化",
    "978": "處決",
    "979": "暫緩",
    "980": "增加額外傷害",
    "981": "增加保護及魔法保護",
    "982": "自動復活",
    "983": "移動速度增加",
    "984": "增加信念值速度",
    "985": "強化寵物攻擊力",
    "986": "強化寵物防禦力",
    "987": "強化同步距離",
    "988": "冰凍免疫",
    "989": "減少擊倒計量條",
    "990": "強化寵物攻擊力,防禦力",
    "991": "精通火魔法強化",
    "992": "精通冰魔法強化",
    "993": "精通雷魔法強化",
    "994": "火鍊金術精通強化",
    "995": "水鍊金術精通強化",
    "996": "土鍊金術精通強化",
    "997": "風鍊金術精通強化",
    "999": "生命的帳幕",
    "1000": "淨化的鼓動僵直免疫",
    "1001": "減速",
    "1002": "和諧的旋律倒數計時",
    "1003": "封印的鍊子",
    "1004": "銳利目光",
    "1005": "神秘帷幕",
    "1006": "月之祝福",
    "1007": "月之詛咒",
    "1008": "擋風罩",
    "1009": "觸電",
    "1010": "占星術技能修練增加",
    "1011": "攻擊力減少",
    "1012": "防禦,保護減少",
    "1013": "移動速度減少",
    "1014": "後續傷害增加",
    "1015": "防禦,保護增加",
    "1016": "物理傷害增加",
    "1017": "特別的強化",
    "1018": "正義",
    "1019": "審判",
    "1020": "教皇",
    "1021": "戀人",
    "1022": "戰車",
    "1023": "月亮",
    "1024": "塔",
    "1025": "隱者",
    "1026": "倒吊人",
    "1027": "世界",
    "1028": "節制",
    "1029": "魔術師",
    "1030": "死神",
    "1031": "加成效果-移動速度增加",
    "1032": "愚者",
    "1033": "星星",
    "1034": "日月",
    "1035": "太陽",
    "1036": "月亮",
    "1037": "日蝕",
    "1038": "平衡強化",
    "1039": "零秒狙擊處罰緩和",
    "1040": "大祝福的旋律舞步",
    "1041": "20週年戰鬥經驗值增加",
    "1042": "抽卡強化",
    "1043": "戰鬥占星術才能技能傷害強化",
    "1045": "魔法傷害增加",
    "1046": "增加鍊金術傷害",
    "1047": "任務完成經驗值增加",
    "1048": "探險經驗值增加",
    "1049": "升段每日次數增加",
    "1050": "寵物重生點數增加",
    "1051": "減緩裝備耐久度減少",
    "1052": "見習騎士團指揮經驗值增加",
    "1053": "寵物點數/特技修練值增加",
    "1054": "卡片神諭增益效果",
    "1055": "大型鐮刀強化",
    "1056": "漸進半透明化",
    "1058": "榮光獻身",
    "1059": "犧牲的庇護",
    "1060": "被聖域束縛的步伐",
    "1061": "聖域之主",
    "1062": "審判重擊移動速度減少",
    "1063": "倒塌的屏障",
    "1064": "荊棘路的盡頭",
    "1065": "零秒嘲諷",
    "1066": "影子束縛術",
    "1067": "半神化布里歐納克,弗拉加拉赫效果增加",
    "1068": "半神化生命力,魔力,耐力恢復效果增加",
    "1069": "魔力盾牌強化",
    "1070": "最大傷害增加",
    "1071": "魔法攻擊力增加",
    "1072": "戰鬥經驗值增加",
    "1073": "零秒嘲諷後遺症",
    "1074": "近距離才能武器最大傷害值增加",
    "1075": "弓術才能武器最大傷害增加",
    "1076": "降低所有屬性注魔的耐力消耗量",
    "1077": "治癒效果增加",
    "1078": "依照治癒效果治療負傷",
    "1079": "礦物化",
    "1080": "米勒的羽毛",
    "1081": "洞察之眼冷卻時間減少",
    "1082": "魔法製造品質強化",
    "1083": "稀原工學品質強化",
    "1084": "造雨的施展時間減少",
    "1085": "造雨冷卻時間減少",
    "1086": "要害貫通強化",
    "1087": "連續攻擊傷害增加",
    "1088": "再生的領域範圍增加",
    "1089": "近距離攻擊抗性",
    "1090": "魔法攻擊抗性",
    "1091": "遠距離攻擊抗性",
    "1092": "海德拉鍊成",
    "1093": "保護最大減少",
    "1094": "魔法保護最大減少",
    "1095": "佩塔克向心力",
    "1096": "生產品品質增加",
    "1097": "復活限制",
    "1098": "凜藍內傷",
    "1099": "人偶暴擊傷害強化",
    "1100": "旋風擺蓮腿強化",
    "1101": "重擊強化",
    "1102": "星之引爆強化",
    "1103": "第七幕:強化狂亂的奔走",
    "1106": "突擊強化",
    "1107": "銳利抵抗等級",
    "1108": "模糊的形象",
    "1109": "目前的意志",
    "1110": "久遠的痕跡",
    "1111": "觸碰痕跡者",
    "1112": "月石氣息",
    "1114": "星界突破強化",
    "1115": "平原Boss用固定傷害1",
    "1116": "增加音樂知識的天籟之音演奏比率",
    "1117": "音樂Buff技能效果增加",
    "1118": "音樂Buff技能持續時間增加",
    "1119": "鐵壁重擊抵抗",
    "1120": "賦予自然力",
    "1121": "魔法攻擊力強化",
    "1122": "槍手之眼",
    "1123": "鍊合轉換",
    "1124": "圖安之歌",
    "1125": "戰鬥占星術天賦魔力值恢復",
    "1126": "迴旋斬擊強化",
    "1127": "戰鬥占星術精通強化",
    "1128": "星象輪迴強化",
    "1129": "精通屬性魔法傷害增加",
    "1130": "強化暴擊傷害",
    "1131": "回音石升級機率增加",
    "1132": "特殊改造成功率增加",
    "1133": "魔力賦予成功率增加",
    "1134": "鍊金術成功率增加",
    "1135": "生產成功率增加",
    "1136": "星塵等級上升機率增加",
    "1137": "貿易信用度增加",
    "1138": "幸運草標記",
    "1139": "紅蘿蔔減益效果",
    "1140": "紅蘿蔔增益效果",
    "1141": "盾牌發動",
    "1142": "盾牌僵直",
    "1143": "特別的幫助",
    "1144": "觸媒效應",
    "1145": "觸媒效應",
    "1146": "屬性共鳴",
    "1147": "召喚噩夢",
    "1148": "地裂螺旋",
    "1149": "特性璞黎每週限制解除",
    "1150": "鍊金術傷害增加",
    "1151": "夢的警戒",
    "1153": "分裂的能量",
    "1154": "羽毛紛飛",
    "1155": "戰場的吶喊",
    "1159": "狂怒意志狀態",
    "1160": "축복의 공예품: 코르플레의 나팔",
    "1161": "弦音編織",
    "1162": "弦音編織持續傷害",
    "1163": "律動步伐",
    "1164": "減少防禦/保護",
    "1165": "減少魔法防禦/魔法保護",
    "1166": "所受傷害增加",
    "1175": "新生增益",
    "1185": "全能火腿搖滾",
    "1186": "全能鼠鼠強化確認",
    "1187": "全能火腿強化增益",
    "1202": "全能火腿強化確認",
    "1225": "火腿增益",
    "10000": "持續傷害瑪奇魔法陣",
    "10001": "物理防禦和保護減少瑪奇魔法陣",
    "10002": "魔法防禦和保護減少瑪奇魔法陣",
    "10003": "生命力恢復瑪奇魔法陣",
    "10004": "肌肉增加瑪奇魔法陣",
    "10005": "脂肪增加瑪奇魔法陣",
    "10007": "悄悄話瑪奇魔法陣",
    "10008": "魔法值恢復瑪奇魔法陣",
    "10009": "耐力值恢復瑪奇魔法陣",
    "10010": "飽足感恢復瑪奇魔法陣",
    "10011": "負傷恢復瑪奇魔法陣",
    "10012": "肌肉減少瑪奇魔法陣",
    "10013": "脂肪減少瑪奇魔法陣",
    "10014": "強化防禦技能瑪奇魔法陣",
    "10015": "強化重擊瑪奇魔法陣",
    "10016": "強化反擊瑪奇魔法陣",
    "10017": "強化突擊瑪奇魔法陣",
    "10018": "強化躍擊瑪奇魔法陣",
    "10019": "強化憤怒衝擊瑪奇魔法陣",
    "10020": "強化猛擊瑪奇魔法陣",
    "10021": "強化終焉斬擊瑪奇魔法陣",
    "10022": "強化蜂擁瑪奇魔法陣",
    "10023": "強化投擲攻擊瑪奇魔法陣",
    "10024": "強化旋風擺蓮腿瑪奇魔法陣",
    "10025": "強化無限斬擊瑪奇魔法陣",
    "10026": "強化跺腳瑪奇魔法陣",
    "10027": "強化暴風防護瑪奇魔法陣",
    "10028": "強化嘲諷瑪奇魔法陣",
    "10029": "強化迴避瑪奇魔法陣",
    "10030": "強化分身術瑪奇魔法陣",
    "10031": "強化狂暴化瑪奇魔法陣",
    "10032": "強化冥想瑪奇魔法陣",
    "10033": "強化雷矢瑪奇魔法陣",
    "10034": "強化雷擊瑪奇魔法陣",
    "10035": "強化絢麗一擊瑪奇魔法陣",
    "10036": "強化雷氣鎖鏈瑪奇魔法陣",
    "10037": "強化火焰瑪奇魔法陣",
    "10038": "強化火球瑪奇魔法陣",
    "10039": "強化火石狂熱瑪奇魔法陣",
    "10040": "強化冰矛瑪奇魔法陣",
    "10041": "強化冰刃瑪奇魔法陣",
    "10042": "強化雹暴瑪奇魔法陣",
    "10043": "強化弩箭魔法瑪奇魔法陣",
    "10044": "強化爆裂術瑪奇魔法陣",
    "10045": "強化移動投擲瑪奇魔法陣",
    "10046": "強化導電反應瑪奇魔法陣",
    "10047": "強化聚精凝魔瑪奇魔法陣",
    "10048": "強化穿心箭瑪奇魔法陣",
    "10049": "強化旋風箭瑪奇魔法陣",
    "10050": "強化支援箭瑪奇魔法陣",
    "10051": "強化毒雲箭瑪奇魔法陣",
    "10052": "強化蜘蛛網射擊瑪奇魔法陣",
    "10053": "強化零秒狙擊瑪奇魔法陣",
    "10054": "強化爆裂箭瑪奇魔法陣",
    "10055": "強化終極射擊瑪奇魔法陣",
    "10056": "強化吸取生命瑪奇魔法陣",
    "10057": "強化水炮瑪奇魔法陣",
    "10058": "強化旋風衝擊瑪奇魔法陣",
    "10059": "強化火焰噴射瑪奇魔法陣",
    "10060": "強化沙暴瑪奇魔法陣",
    "10061": "強化冰風暴瑪奇魔法陣",
    "10062": "強化火花瑪奇魔法陣",
    "10063": "強化高壓火爆瑪奇魔法陣",
    "10064": "強化黃金時間瑪奇魔法陣",
    "10065": "強化連續技能 : 突拳瑪奇魔法陣",
    "10066": "強化連續技能 : 導電拳擊瑪奇魔法陣",
    "10067": "強化連續技能 : 狂暴拳擊瑪奇魔法陣",
    "10068": "強化連續技能 : 螺旋勾拳瑪奇魔法陣",
    "10069": "強化連續技能 : 翻跟斗瑪奇魔法陣",
    "10070": "強化連續技能 : 飛踢瑪奇魔法陣",
    "10071": "強化連續技能 : 猛烈突擊瑪奇魔法陣",
    "10072": "強化復原瑪奇魔法陣",
    "10073": "強化後退瑪奇魔法陣",
    "10074": "強化誘惑之歌瑪奇魔法陣",
    "10075": "強化旋律衝擊瑪奇魔法陣",
    "10076": "強化幻想的合唱瑪奇魔法陣",
    "10077": "強化戰場的序曲瑪奇魔法陣",
    "10078": "強化搖籃曲瑪奇魔法陣",
    "10079": "強化活潑板瑪奇魔法陣",
    "10080": "強化忍耐的音樂瑪奇魔法陣",
    "10081": "強化豐年歌瑪奇魔法陣",
    "10082": "強化進行曲瑪奇魔法陣",
    "10083": "強化死亡之舞瑪奇魔法陣",
    "10084": "強化第二幕 : 激增的憤怒瑪奇魔法陣",
    "10085": "強化第一幕 : 偶然的衝突瑪奇魔法陣",
    "10086": "強化第四幕 : 嫉妒的化身瑪奇魔法陣",
    "10087": "強化第六幕 : 誘惑的圈套瑪奇魔法陣",
    "10088": "強化第七幕 : 狂亂的奔走瑪奇魔法陣",
    "10089": "強化第九幕 : 甦醒的生命瑪奇魔法陣",
    "10090": "強化幕後操作瑪奇魔法陣",
    "10091": "強化幕前魁儡瑪奇魔法陣",
    "10092": "強化騎槍反擊瑪奇魔法陣",
    "10093": "強化騎槍衝擊瑪奇魔法陣",
    "10101": "強化魔力凝聚瑪奇魔法陣",
    "10102": "強化防護壁瑪奇魔法陣",
    "10103": "強化造雨瑪奇魔法陣",
    "10104": "強化海德拉鍊成瑪奇魔法陣",
    "10105": "強化巨魔像鍊成瑪奇魔法陣",
    "10106": "強化十字槍擊瑪奇魔法陣",
    "10107": "強化拉近瑪奇魔法陣",
    "10108": "強化退遠瑪奇魔法陣",
    "10109": "強化衝射瑪奇魔法陣",
    "10110": "強化彈雨瑪奇魔法陣",
    "10111": "強化裝彈瑪奇魔法陣",
    "10112": "強化雙槍射擊瑪奇魔法陣",
    "10113": "強化手裏劍突擊瑪奇魔法陣",
    "10114": "強化手裏劍暴風瑪奇魔法陣",
    "10115": "強化影子束縛術瑪奇魔法陣",
    "10116": "強化影子隱身術瑪奇魔法陣",
    "10117": "強化手裏劍爆破瑪奇魔法陣",
    "10118": "強化灰色煙幕術瑪奇魔法陣",
    "10119": "強化櫻花雨瑪奇魔法陣",
    "10120": "強化鎖鏈攻擊瑪奇魔法陣",
    "10121": "強化鎖鏈刺擊瑪奇魔法陣",
    "10122": "強化闇夜圓舞曲瑪奇魔法陣",
    "10123": "強化闇夜掠擊瑪奇魔法陣",
    "10124": "強化闇夜處刑瑪奇魔法陣",
    "10125": "強化黑闇掃蕩瑪奇魔法陣",
    "10126": "強化黑闇轉換瑪奇魔法陣",
    "10127": "強化鎖鏈躍疾瑪奇魔法陣",
    "10128": "強化死神烙印瑪奇魔法陣",
    "10129": "強化黑闇解放瑪奇魔法陣",
    "10130": "強化信念解放瑪奇魔法陣",
    "10131": "鐮刀斬擊技能強化瑪奇魔法陣",
    "10132": "星之引爆技能強化瑪奇魔法陣",
    "10133": "星界突破技能強化瑪奇魔法陣",
    "10134": "迴旋斬擊技能強化瑪奇魔法陣",
    "10135": "星象輪迴技能強化瑪奇魔法陣",
    "10136": "黃道蔓延技能強化瑪奇魔法陣",
    "10137": "引力空間技能強化瑪奇魔法陣",
    "10138": "星魂卡陣技能強化瑪奇魔法陣",
};
